"use client";

import Link from "@app/_components/Link";
import { useMarket } from "@app/_context";
import useTranslate from "@app/_hooks/useTranslate";
import { Button } from "@ui/button";
import { DialogTrigger } from "@ui/dialog";
import { User } from "lucide-react";
import { ComponentProps } from "react";
import useAuth from "../hooks/useAuth";
import DesktopSignIn from "./DesktopSignIn";

function UserButton({ className, ...props }: ComponentProps<typeof Button>) {
  const t = useTranslate();
  const { market } = useMarket().state;
  const { authenticated } = useAuth();

  if (authenticated) {
    return (
      <Button
        size="auto"
        variant="link"
        className={className}
        asChild
        {...props}
      >
        <Link locale={market.locale} href="/account/orders">
          <User strokeWidth={1} className="size-5" />
          <span className="sr-only">{t("account")}</span>
        </Link>
      </Button>
    );
  }

  return (
    <DialogTrigger asChild>
      <Button size="auto" variant="link" className={className} {...props}>
        <User strokeWidth={1} className="size-5" />
        <span className="sr-only">{t("signIn")}</span>
      </Button>
    </DialogTrigger>
  );
}

export default function AuthButton(props: ComponentProps<typeof Button>) {
  return (
    <DesktopSignIn>
      <UserButton {...props} />
    </DesktopSignIn>
  );
}
